/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { useEffect, useState } from "react";
import { useToast } from "../../../context/toast-context";
import useAPIHandler from "../../../hook/use-api-handler";
import { getDayName } from "../../../utils/common";
import { logger } from "../../../utils/logger";
import { OrgWeeklyOffSchema } from "./org-weekly-off-validation";
import { WEEKLY_OFF_INITIAL_STATE } from "./weekly-off-constant";

const useOrgWeeklyOffService = () => {
    const [orgWeeklyOffModal, setOrgWeeklyOffModal] = useState(false);
    const handleClickOrgWeeklyOffModalOpen = () => setOrgWeeklyOffModal(true);
    const handleClickOrgWeeklyOffModalClose = () => setOrgWeeklyOffModal(false);
    const [orgWeeklyOffInputs, setOrgWeeklyOffInputs] = useState(structuredClone(WEEKLY_OFF_INITIAL_STATE))
    const [orgWeeklyOffData, setOrgWeeklyOffData] = useState([]);
    const [orgWeeklyOffUiLoading, setOrgWeeklyOffUiLoading] = useState(false);
    const [errors, setErrors] = useState([])
    const [createFormUpdateLoading, setCreateFormUpdateLoading] = useState(false);
    const [empWeeklyOffId, setEmpWeeklyOffId] = useState(null)
    const [orgWeeklyOffDeleteModal, setOrgWeeklyOffDeleteModal] = useState(false)
    const [selectedOrgWeeklyOff, setSelectedOrgWeeklyOff] = useState(null)
    const { fetchData } = useAPIHandler()
    const { showToastMessage } = useToast();
    const handleClickOpenAddModal = () => {
        setOrgWeeklyOffInputs(structuredClone(WEEKLY_OFF_INITIAL_STATE));
        setErrors({});
        handleClickOrgWeeklyOffModalOpen();
    }
    const handleClickOpenEditModal = (data) => {
        fetchOrgWeeklyOffDataById(data)
        setErrors({});
        handleClickOrgWeeklyOffModalOpen()
        setOrgWeeklyOffInputs({
            ...data
        })
    }
    const handleClickOpenDeleteModal = () => {
        setOrgWeeklyOffDeleteModal(true)
    }
    const handleClickCloseDeleteModal = () => {
        setOrgWeeklyOffDeleteModal(false)
    }
    const handleChange = (e, name) => {
        let value = e;
        if (e & e.target) {
            value = e.target.value;
            name = e.target.name
        }
        setOrgWeeklyOffInputs((prevInfo) => ({
            ...prevInfo,
            [name]: value
        }))
    }
    const handleSubmit = async () => {
        setCreateFormUpdateLoading(true);
        const {
            days,
            repeat
        } = orgWeeklyOffInputs || {};
        const { error } = OrgWeeklyOffSchema.validate({
            days,
            repeat
        }, {
            abortEarly: false,
        });
        if (error && error?.details?.length > 0) {
            const validationErrors = error.details.reduce((acc, err) => {
                const pathname = err.path.join(".");
                acc[pathname] = err.message;
                return acc;
            }, {});
            setErrors(validationErrors)
            setCreateFormUpdateLoading(false);
        } else {
            setErrors({});
            try {
                const url = orgWeeklyOffInputs?.weekly_holiday_id ? `organization/update-org-weekly-holiday/update/${orgWeeklyOffInputs.weekly_holiday_id}` : "organization/create-org-weekly-holiday/"
                const payload = {
                    url: url,
                    method: "POST",
                    data: {
                        days,
                        repeat
                    }
                }
                const response = await fetchData(payload);
                if (response?.data?.weekly_holiday_id) {

                    showToastMessage({ message: "Orgranization Weeklyoff Created Successfully!" })
                    fetchOrgWeeklyOffData();
                }
                setCreateFormUpdateLoading(false);
                handleClickOrgWeeklyOffModalClose()
            } catch (error) {
                if (error?.type === "JoiValidationError") {
                    const errorsAll = {};
                    error?.errors?.map((item) => {
                        const { field, message } = item;
                        errorsAll[field] = message;
                    });

                    showToastMessage({
                        message:
                            Object.keys(errorsAll).length > 0
                                ? "Validation Error!"
                                : "Something went wrong!",
                        color: "danger",
                    });
                    setErrors(errorsAll);
                }

                if (error?.type === "GeneralError") {
                    showToastMessage({
                        message: error.message || "An unknown general error occurred.",
                        color: "danger",
                    });
                }
                setCreateFormUpdateLoading(false);
                handleClickOrgWeeklyOffModalClose()
            }
        }
    }
    logger.log(errors,"hello123")
    const fetchOrgWeeklyOffData = async () => {
        setOrgWeeklyOffUiLoading(true);
        try {
            const result = await fetchData({
                url: 'organization/org-weekly-holidays',
                method: 'GET',
            });
            setOrgWeeklyOffUiLoading(false)
            setOrgWeeklyOffData(result?.data)
        } catch {
            setOrgWeeklyOffUiLoading(false)
        }
    }
    const fetchOrgWeeklyOffDataById = async (data) => {
        logger.log(data, "fetchOrgWeeklyOffDataById")
        const daysOfWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
        const queryParams = daysOfWeek
            .filter(day => data[day])
            .map(day => `${day}=true`)
            .join('&');
        try {
            const result = await fetchData({
                url: `organization/org-weekly-holiday/${data?.org_weekly_holiday_id}?${queryParams}`,
                method: 'GET',
            })
            setEmpWeeklyOffId(result?.data?.organizations?.employee_weekly_holidays[0]?.employee_weekly_holiday_id)

        } catch {
            setOrgWeeklyOffUiLoading(false)
        }
    }

    const handleClickDeletebtn = (data) => {
        handleClickOpenDeleteModal();
        setSelectedOrgWeeklyOff(data);
    }
    const handleDelete = async () => {
        setCreateFormUpdateLoading(true);
        const selectedDayName=getDayName(selectedOrgWeeklyOff?.days)
        logger.log("selected-day",selectedDayName)
        try {
            const res = await fetchData({
                url: `organization/delete-org-weekly-holiday/${selectedOrgWeeklyOff?.weekly_holiday_id}?${selectedDayName.toLowerCase()}=true`,
                method: 'DELETE',
                data: []
            })
            showToastMessage({ message: "Weekly Off Deleted successfully!" });
            handleClickCloseDeleteModal();
            fetchOrgWeeklyOffData();
            setCreateFormUpdateLoading(false);
        } catch (error) {
            if (error?.type === "JoiValidationError") {
                const errorsAll = {};

                error?.errors?.map((item) => {
                    const { field, message } = item;
                    errorsAll[field] = message;
                });

                showToastMessage({
                    message:
                        Object.keys(errorsAll).length > 0
                            ? "Validation Error!"
                            : "Something went wrong!",
                    color: "danger",
                });
                setErrors(errorsAll);
            }

            if (error?.type === "GeneralError") {
                showToastMessage({
                    message: error.message || "An unknown general error occurred.",
                    color: "danger",
                });
            }
            setCreateFormUpdateLoading(true);
        }

    }
    logger.log(orgWeeklyOffInputs, "orgWeeklyOffInputs")
    useEffect(() => {
        fetchOrgWeeklyOffData();
    }, [])
    return {
        orgWeeklyOffModal,
        handleClickOrgWeeklyOffModalOpen,
        handleClickOrgWeeklyOffModalClose,
        handleChange,
        handleSubmit,
        orgWeeklyOffInputs,
        setOrgWeeklyOffInputs,
        errors,
        orgWeeklyOffData,
        handleClickOpenEditModal,
        handleClickOpenAddModal,
        orgWeeklyOffDeleteModal,
        handleClickOpenDeleteModal,
        handleClickCloseDeleteModal,
        handleClickDeletebtn,
        handleDelete,
        createFormUpdateLoading
    }
}

export default useOrgWeeklyOffService